export enum UserTypes {
  'STANDARD',
  'EXTENDED',
}
